import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'logout',
    templateUrl: './logout.component.html'
})
export class LogoutComponent {

    message: string;
    loggingOut: boolean;

    constructor(
        private authService: AuthService
    ) {
        this.logout();
    }

    logout() {
        this.message = "Logging you out...";
        this.loggingOut = true;
        this.authService.logout();
    }
}
